import React from "react";
import HeadingBox from "./homecomponent/headingBox";

const Achievements = () => {
  const tophead = "ACHIEVEMENTS";
  const subhead = " Our Construction Milestones";
  return (
    <>
      <div className="achievementWrapper">
        <img
          className="leftGridachi"
          src="/images/home/leftGrid.png"
          alt="..."
        />
        <img
          className="rightGridachi"
          src="/images/home/leftGrid.png"
          alt="..."
        />
        <img
          className="blueprintrightachi"
          src="../../../images/home/benefit-right-blueprint.png"
          alt=""
        />

        <HeadingBox topheading={tophead} subheading={subhead} />

        <p style={{ maxWidth: "740px" }} className="para-text text-black mt-4">
          Embark on a construction voyage with us, where our milestones beam
          like guiding stars, showcasing our unwavering dedication to innovation
          and leading the way.{" "}
        </p>
        <div className="achieveBoxContainer">
          <div className="achieveboxleft">
            <img
              className="blur-pic"
              src="/images/home/blurImg.webp"
              alt="..."
            />
            <img
              className="box-left-minipic"
              src="/images/home/achieveminipic.webp"
              alt="..."
            />
          </div>
          <div className="achieveboxright">
            <div className="rightboxCenterDiv">
              <p
                style={{ fontSize: "48px" }}
                className="main-gradient-heading "
              >
                Accomplishments
              </p>
              <p className="accompish-text">
                Group LanDevAI achieves greatness in building innovation,
                receiving awards for their outstanding work. Their commitment to
                excellence sets them apart, redefining the meaning of
                achievement in the construction world.
              </p>
              <button className="read-btn">Read more</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Achievements;
